/**
 * Normalizes Grafana-style "Value N" field names and Chronosphere-style
 * "Value (N)" field names to a shared canonical form so that column overrides
 * match regardless of which convention was used when the dashboard was saved.
 */
export function normalizeValueFieldName(name: string): string {
  // "Value 1" → "Value", "Value N" → "Value (N)"   (Grafana outer-join naming)
  const grafanaMatch = name.match(/^Value (\d+)$/);
  const suffix = grafanaMatch?.[1];
  if (suffix !== undefined) {
    const n = parseInt(suffix, 10);
    return n === 1 ? 'Value' : `Value (${n})`;
  }
  return name;
}
